/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => React.FC>({
  tv: () => require("./StorefrontPage.tv").default,
  default: () => require("./StorefrontPage").default,
})();
